// extracted by mini-css-extract-plugin
module.exports = {"sort":"Tu-z","selected":"Uu-z","disabled":"Vu-z"};